import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';

function JiliPlayPatrioticPromo (props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const domain = (brandId == 31 || brandId == 32 || brandId == 61) ? "YOLO247" : (brandId == 39 || brandId == 40) ? "FOMO7" : (brandId == 46 || brandId == 47) ? "FUN88" : 'IW247';

    return (
        <>
            <InformationWrapper>
                <Container>
                    <TitleText>
                        <img src={`${config.imageV3Host}/static/cashsite/${theme.image.HeadTextImage}`} className='headTextImg' alt="image" />
                        <p>Celebrate India's <strong>78th Independence Day</strong> with<br /> <strong>{domain}</strong> and <strong>JILI</strong> Slots!</p>
                        <img src={`${config.imageV3Host}/static/cashsite/${theme.image.JiliPromoDateImg}`} className='dateImg' alt="Date" />
                        <p>Spin any JILI slot <strong>78 times</strong> a day to unlock <strong>78 Bonus Spins</strong> <br />
                        for the next day! Keep the reels rolling in this patriotic <br />
                        slot adventure and honor <strong>78 years</strong> of freedom with a <br />
                        <strong>₹78,000 prize pool</strong> in Bonus Spins!</p>
                    </TitleText>
                    <ImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.SpinImagePricePool}`}
                            alt="Price Pool"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                            className="pricepool_image"
                        />
                    </ImageWrapper>
                </Container>
                {!(brandId == 33 || brandId == 34) && <BorderLine></BorderLine>}
                <Container className={(brandId == 33 || brandId == 34) ? 'morePadding' : 'bgRadial morePadding'}>
                    <HowToImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.PatroiticJoinImg}`}
                            alt="How to Join"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </HowToImageWrapper>
                    <HowToJoinStep>
                        <img src={`${config.imageV3Host}/static/cashsite/${theme.image.jiliSpinHowToJoin}`} className='howToJoin' alt="How To Join" />
                        <ul>
                            <li><strong>Log in</strong>&nbsp;to your {domain} account.</li>
                            <li>Navigate to the&nbsp;<strong>JILI Slots</strong>&nbsp;section.</li>
                            <li>Spin any JILI slot at least&nbsp;<strong> 78 times in a single day&nbsp;</strong> with a minimum bet of&nbsp;<strong> ₹50 per spin.</strong></li>
                            <li>Receive&nbsp;<strong>78 Bonus Spins</strong>, credited for the next day.</li>
                            <li>Keep spinning daily to keep winning!</li>
                        </ul>
                    </HowToJoinStep>
                </Container>
                {!(brandId == 33 || brandId == 34) && <BorderLine></BorderLine>}
                <TermsAndCondition className={!(brandId == 33 || brandId == 34) && 'bgRadial'}>
                    <MainTitle>Terms And Conditions:</MainTitle>
                    <ul>
                        <li>Only spins with a <strong>minimum bet of ₹50</strong> on JILI Slots count toward the 78-spin daily requirement.</li>
                        <li>Bonus Spins are valued at ₹1 per spin and will be credited by 12:00 AM IST the following day throughout the campaign period (August 1-31, 2025). Bonus Spins are valid only on the following games: Money Coming, Super Ace, Fortune Gems, Fortune Gems 2, and Fortune Gems 3.</li>
                        <li>Winnings from Bonus Spins are subject to a <strong>5x wagering requirement</strong> before being credited to the main account.</li>
                        <li>All 78 Bonus Spins are restricted to one eligible game—the first game the player opens after the spins are credited</li>
                        <li>{domain} reserves the right to disqualify players for fraudulent activity or abuse of the promotion.</li>
                        <li>Standard {domain} terms and conditions apply.</li>
                    </ul>
                </TermsAndCondition>
            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(JiliPlayPatrioticPromo));

// Styled Component.
const HowToJoinStep = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 1rem;
    padding-left: 5rem;

    img {
        width: 335px;
        max-width: 100%;
    }

    ul {
        display: flex;
        flex-direction: column;
        margin: 0;
        padding: 0;
        gap: 1rem;

        li {
            color: #FFF;
            text-align: left;
            font-size: 17px;
            font-style: normal;
            line-height: 150%;
            text-transform: capitalize;
            list-style-type: none;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-wrap: wrap;
            padding-left: 2.5rem;
            position: relative;

            ::before {
                content: "";
                display: flex;
                width: 26.853px;
                height: 26.853px;
                background: url(${config.imageV3Host}/static/cashsite/${theme("image.CheckedJiliTik")});
                background-position: center;
                background-size: cover;
                background-repeat: no-repeat;
                overflow: hidden;
                position: absolute;
                left: 5px;
            }
        }
    }
`;

const HowToImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 673px;
        /* max-width: 100%; */
    }
`;

const BorderLine = styled.div`
    width: 100%;
    /* background: radial-gradient(#ffce4f 0%, rgba(0, 0, 0, 0) 50%); */
    background: ${theme('palette.jiliPlaySpinBorderLineBg')};
    height: 2px;
    align-self: center;
`;
const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 1.5rem 0 0rem 0;
    margin: 0em 1.2em 1.2em 1.2em;
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.jiliPlayBonusPromoInnerBG")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    border: 1px solid #bfbfbf;

    h2 {
        color: #E6FF00;
        text-align: center;
        font-size: 23px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        background: ${theme('palette.LiveJackPot2025InformationWrapperH2Text')};
        background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2TextClip')};
        -webkit-background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2WebkitClip')};
        -webkit-text-fill-color: ${theme('palette.LiveJackPot2025InformationWrapperH2TextWebkitFill')};
    }

    .paddingTopBtm {
        margin: 0 auto;
        margin-bottom: 2rem;
    }

    .footerText {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 120% */
        text-transform: capitalize;
        margin: 10px 0px 0px 0px;
    }

    .bgRadial {
        /* background: radial-gradient(38.26% 45.18% at 50% 0%, rgba(239, 205, 65, 0.12) 0%, rgba(2, 13, 2, 0.00) 100%); */
        background: ${theme('palette.jiliPlaySpinBgRadial')};
    }
`;

const TitleText = styled.div`
    width: calc(100% - 622px);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: ${theme('palette.liveJackpotTittleTextPadding')};
    position: relative;
    gap: 1.5rem;


    p {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        text-transform: capitalize;
        margin: 0;
    }

    .dateImg {
        width: 180px;
    }

    .headTextImg {
        width: 480px;
    }
`;

const ImageWrapper = styled.div`
    width: 622px;
    height: 573px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    position: relative;

    .pricepool_image {
        width: 100%;
        max-width: 100%;
        position: absolute;
        bottom: -3px;
        left: 0;
    }
`;


const Container = styled.div`
    width: 100%;
    max-width: 1366px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0 auto;

    &.morePadding {
        padding-top: 5rem;
        padding-bottom: 3rem;
    }
`;

const MainTitle = styled.h4`
    color: #FFEE00;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 35px; /* 175% */
    text-transform: capitalize;
    margin: 3px 0px 15px 0px;
`

const TermsAndCondition = styled.div`
    width: 100%;
    max-width: 1010px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    padding-top: 3rem;

    & li {
        color: #FFF;
        text-align: justify;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px; /* 116.667% */
        text-transform: capitalize;
        list-style-type: decimal;
        padding-bottom: 1.5rem;
    }

    & h4 {
        background: linear-gradient(91deg, #D2D2D2 2.89%, #FFF 52.11%, #C8C8C8 99.8%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        font-size: 30px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;

        :after {
            content: "";
            width: 107px;
            height: 3px;
            display: flex;
            margin: 0 auto;
            margin-top: 1rem;
            background: linear-gradient(91deg, #DBDBDB 2.89%, #FFF 52.11%, #CACACA 99.8%);
        }
    }
`;
